import { KeyValue } from '@/main/models/common';
import { ManufacturerRequest } from '@/main/models/request';
import { IInitialReducerData } from '@/main/services/reducerUtils';

export enum ManufacturerTypes {
  GET_MANUFACTURERS = '@manufacturer/GET_MANUFACTURERS',
  SAVE_MANUFACTURERS = '@manufacturer/SAVE_MANUFACTURERS',
  RESET_REDUCER_MANUFACTURERS = '@manufacturer/RESET_REDUCER_MANUFACTURERS'
}

export interface ManufacturerState {
  readonly manufacturers: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
  readonly isolated: {
    [key: string]: IInitialReducerData;
  };
}

export interface GetManufacturers {
  type: typeof ManufacturerTypes.GET_MANUFACTURERS;
  payload: {
    request: ManufacturerRequest;
    keyReducer: string;
  };
}

export interface SaveManufacturers {
  type: typeof ManufacturerTypes.SAVE_MANUFACTURERS;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
    keyReducer: string;
  };
}

export interface ResetReducerManufacturers {
  type: typeof ManufacturerTypes.RESET_REDUCER_MANUFACTURERS;
  payload: {
    keyReducer: string;
  };
}

export type ManufacturerActionTypes =
  | GetManufacturers
  | SaveManufacturers
  | ResetReducerManufacturers;

